<template>
  <body>
    <ModalAutores :autores="autores" v-show="modalAutores"
      @cerrar="cerrarModal"
      @recargar="recargarAutores"
      @AddAutor="otroAutor"/>
    <aside class="Blk-1">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div id="" class="Blk-Campo">
          <p id="titReg">Títulos registrados</p>
          <select name="nomSepOrArt" id="nombreSeparata" class="campo"
            :disabled = 'habBotAndCamp.habCampo'
            v-model="separataSel" @change.prevent="mostrarSeparata(separataSel._id)">
            <option v-for="nombreSeparata in nombresSeparatas"
              :key="nombreSeparata._id"
              :value="nombreSeparata">
              {{nombreSeparata.titulo}}
            </option>
          </select>
        </div>
        <form @change="cambioForm">
          <div class="Blk-Campo">
            <p>Nombre completo*</p>
            <textarea name="nomPubPer" class="campo" ref="nomPubPer" rows="2" id=""
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.titulo"
              spellcheck="false"
              autofocus>
            </textarea>
            <div class="minusculas">
              <button @click.prevent="lowCase" id="lowCaseBtn"
                :disabled = '!habBotAndCamp.habCampo'>AB->ab
              </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Autor(es)*</p>
            <div class="campo" @change="cambioAutores" >{{autoresVista}}</div>
            <div class="botonesAut">
              <button class="botAut" @click.prevent="openModAutores" :disabled = '!habBotAndCamp.habCampo'>+</button>
              <button class="botAut" @click.prevent="delAutor" :disabled = '!habBotAndCamp.habCampo'> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Publicación*</p>
            <input type="text" name="publicacion" class="campo" ref="pub" list="pub" autocomplete="off"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.publicacion">
            <datalist id="pub">
              <option value="Boletín de la Sociedad Venezolana de Espeleología">Boletín de la Sociedad Venezolana de Espeleología</option>
              <option value="Boletín El Guacharo">Boletín El Guacharo</option>
            </datalist>
          </div>
          <div class="Blk-Campo">
            <p>Número</p>
            <input type="text" name="numero" class="campo"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.numero">
          <!-- </div>
          <div class="Blk-Campo"> -->
            <p>Volumen</p>
            <input type="text" name="volumen" class="campo"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.volumen">
          </div>
          <div class="Blk-Campo">
            <p>Año*</p>
            <input type="text" name="anyo" class="campo" ref="anyo"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.anyo">
          <!-- </div>
          <div class="Blk-Campo"> -->
            <p>Recibido</p>
            <input type="text" name="recibido" class="campo" ref="recibido"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.recibido">
          </div>
          <div class="Blk-Campo">
            <p>Área*</p>
            <select
              name="area"
              class="campo"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.area">
                <option value="1">Antropoespeleología</option>
                <option value="2">Bioespeleología</option>
                <option value="3">Geoespeleología</option>
                <option value="4">Espeleoturismo</option>
                <option value="5">Otras</option>
            </select>
            <p>Idioma</p>
            <input type="text" name="idioma" class="campo" ref="idioma" list="idiomas" autocomplete="off"
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.idioma">
            <datalist id="idiomas">
              <option value="Español">Español</option>
              <option value="Francés">Francés</option>
              <option value="Italiano">Italiano</option>
              <option value="Inglés">Inglés</option>
              <option value="Japonés">Japonés</option>
              <option value="Portugués">Portugués</option>
            </datalist>
          </div>
          <div class="Blk-Campo">
            <p>Resumen</p>
            <textarea name="resumen" class="campo" ref="" rows="5" id=""
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.resumen">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <textarea name="palClave" class="campo" ref="" rows="2" id=""
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.palsClave">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Abstract</p>
            <textarea name="abstract" class="campo" ref="" rows="5" id=""
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.abstract">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Key words</p>
            <textarea name="keyWords" class="campo" ref="" rows="2" id=""
              :disabled = '!habBotAndCamp.habCampo'
              v-model.trim="separataVista.keyWords">
            </textarea>
          </div>
          <div class="quitaSaltoLineas">
            <button @click.prevent="noLineBreaks"
              :disabled = '!habBotAndCamp.habCampo'
              class="Btn-BRL">
              Borrar saltos de línea en Resumen y Pals. Clave
            </button>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Formato papel</p>
              <input type="checkbox" name="fPapel"
                v-model.trim="separataVista.papel"
                :disabled = '!habBotAndCamp.habCampo'>
            </div>
            <div class="check">
              <p>Formato electrónico</p>
              <input type="checkbox" name="fElec"
                v-model.trim="separataVista.digital"
                :disabled = '!habBotAndCamp.habCampo'>
            </div>
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.habCampo'
                v-model.trim="separataVista.reservado">
            </div>
          </div>
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
          :desacMas="!habBotAndCamp.actMas"
          :desacEdit="!habBotAndCamp.actEdi"
          :desacMenos="!habBotAndCamp.actMen"
          :desacSave="!habBotAndCamp.actSav"
          @nuevo="nuevaSeparata"
          @editar="editarSeparata"
          @del="borrarSeparata"
          @save="saveSeparata"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalAutores from '../components/ModalAutores.vue'
import axios from 'axios'
export default {
  name: 'FormSeparata',
  components: { BotonesCRUD, ModalAutores },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getTitulosSeparatas()
    this.getAutores()
    this.activaModo('INI')
  },
  data () {
    return {
      nombresSeparatas: [],
      separataSel: [],
      separataSelBkUp: [],
      separataVista: {},
      separataVistaBkUp: {},
      verSelectSeparata: false,
      autores: [],
      modalAutores: false,
      autoresSeparata: [],
      autoresSeparataBkUp: [],
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        habCampo: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getTitulosSeparatas () {
      try {
        const url = `${this.URLbase}/separatas/getSeparatasList`
        const res = await axios.get(url)
        this.nombresSeparatas = res.data
      } catch (error) {
        alert(error)
      }
    },
    async getDatosSeparata_Art (IdSepOrArt) {
      try {
        const url = `${this.URLbase}/separatas/getSeparataData`
        const separataId = { _id: IdSepOrArt }
        const res = await axios.post(url, separataId)
        this.separataVista = res.data
        this.autoresSeparata = res.data.autores
      } catch (error) {
        alert(error)
      }
    },
    mostrarSeparata (IdSepOrArt) {
      this.getDatosSeparata_Art(IdSepOrArt)
      this.activaModo('S')
    },
    blanquearSeparataVista () {
      this.separataVista = {}
      this.separataSel = []
      this.autoresSeparata = []
    },
    nuevaSeparata () {
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.separataVistaBkUp = JSON.parse(JSON.stringify(this.separataVista))
        this.autoresSeparataBkUp = JSON.parse(JSON.stringify(this.autoresSeparata))
        this.separataSelBkUp = this.separataSel
        this.separataVista = {}
        this.activaModo('MAS')
        this.autoresSeparata = []
        this.separataSel = []
      } else {
        this.separataSel = this.separataSelBkUp
        if (this.separataSel.titulo) {
          this.separataVista = JSON.parse(JSON.stringify(this.separataVistaBkUp))
          this.autoresSeparata = JSON.parse(JSON.stringify(this.autoresSeparataBkUp))
          this.activaModo('S')
        } else {
          this.blanquearSeparataVista()
          this.activaModo('INI')
        }
      }
    },
    editarSeparata () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      if (this.IsModoSalirEdi) {
        this.separataVistaBkUp = JSON.parse(JSON.stringify(this.separataVista))
        this.autoresSeparataBkUp = JSON.parse(JSON.stringify(this.autoresSeparata))
        this.separataSelBkUp = this.separataSel
        this.activaModo('EDI')
      } else {
        this.separataVista = JSON.parse(JSON.stringify(this.separataVistaBkUp))
        this.autoresSeparata = JSON.parse(JSON.stringify(this.autoresSeparataBkUp))
        this.separataSel = this.separataSelBkUp
        this.activaModo('S')
      }
    },
    cambioForm () {
      if (this.IsModoSalirMas) {
        if (this.minData) {
          this.activaModo('MASs')
        } else {
          this.activaModo('MAS')
        }
      } else if (this.IsModoSalirEdi) {
        if (this.minData) {
          this.activaModo('EDIs')
        } else {
          this.activaModo('EDI')
        }
      }
    },
    async borrarSeparata () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este artículo/separata. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C')
      if (response === 'borrar') {
        const url = `${this.URLbase}/separatas/deleteSeparata`
        const separataId = { _id: this.separataVista._id }
        try {
          const result = await axios.post(url, separataId, {
            headers: {
              authorization: this.token
            }
          })
          // console.log('Resultado:', result.status)
          switch (result.status) {
            case 200:
              this.blanquearSeparataVista()
              this.alertJoa('¡Registro borrado con éxito!', 'S')
              this.getTitulosSeparatas()
              break
            case 500:
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
              break
            default:
              this.alertJoa('Algo salió mal, intenta otra vez', 'E')
          }
        } catch (error) {
          // console.error(error)
          this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
        }
      }
    },
    async saveSeparata () {
      this.separataVista.autores = this.autoresSeparata
      try {
        const url = `${this.URLbase}/separatas/save`
        const separata = this.separataVista
        await axios.post(url, separata)
        // console.log(res)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                break
            }
          })
      } catch (error) {
        alert(error)
      }
      this.getTitulosSeparatas()
      this.IsModoSalirMas = false
      this.IsModoSalirEdi = false
      this.blanquearSeparataVista()
      this.activaModo('INI')
    },
    openModAutores () {
      if (this.separataVista.titulo) { this.modalAutores = true }
    },
    recargarAutores () {
      this.getAutores()
    },
    // Elimina el último autor asociado a la separata
    delAutor () {
      this.autoresSeparata.pop()
    },
    // Añade los autores en orden de una separata
    otroAutor (autorRecibido) {
      if (!this.autoresSeparata.includes(autorRecibido)) { this.autoresSeparata.push(autorRecibido) }
    },
    cerrarModal () {
      this.modalAutores = false
    },
    async getAutores () {
      try {
        const url = `${this.URLbase}/autores/listAutores`
        const res = await fetch(url)
        this.autores = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    activaModo (modo) {
      let confModo = []
      switch (modo) {
        case 'INI':
          confModo = [1, 0, 0, 0, 0] // inicial, solo botón Más está habilitado
          break
        case 'S':
          confModo = [1, 1, 1, 0, 0] // elemento Seleccionado: Más, Edit y Menos habilitados
          break
        case 'MAS':
          confModo = [1, 0, 0, 0, 1] // Más pulsado, habilita campos y Mas habilitado con texto 'Cancelar'
          break
        case 'MASs':
          confModo = [1, 0, 0, 1, 1] // Mas con datos mínimos para guardar, botón Guardar habilitado
          break
        case 'EDI':
          confModo = [0, 1, 0, 0, 1] // Editar pulsado, habilita campos y Editar habilitado con texto 'Cancelar'
          break
        case 'EDIs':
          confModo = [0, 1, 0, 1, 1] // Editar con datos mínimos para guardar, botón Guardar habilitado
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    lowCase () {
      this.separataVista.titulo = this.separataVista.titulo.toLowerCase()
      this.cambioForm()
    },
    noLineBreaks () {
      this.separataVista.resumen = this.separataVista.resumen.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.separataVista.resumen = this.separataVista.resumen.replaceAll('  ', ' ')
      this.separataVista.abstract = this.separataVista.abstract.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.separataVista.abstract = this.separataVista.abstract.replaceAll('  ', ' ')
      this.separataVista.palsClave = this.separataVista.palsClave.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.separataVista.palsClave = this.separataVista.palsClave.replaceAll('  ', ' ')
      this.separataVista.keyWords = this.separataVista.keyWords.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.separataVista.keyWords = this.separataVista.keyWords.replaceAll('  ', ' ')
      this.cambioForm()
    }
  },
  computed: {
    autoresVista () {
      // const A = this.autoresSeparata.map((e) => this.autores.find((autor) => autor._id === e))
      return this.autoresSeparata.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')
    },
    minData () {
      return !!(this.separataVista.titulo && !!this.autoresSeparata && this.separataVista.publicacion &&
              this.separataVista.anyo && this.separataVista.area)
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    autoresVista () {
      // if ((this.IsModoSalirEdi || this.IsModoSalirMas) && this.autoresId.length > 0) {
      this.cambioForm()
      // } // El condicional evita que con formulario recien abierto y pulsando Nuevo se habilite Editar
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 5%;
}
article.Form {
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
#titReg{
  font-weight: bold;
  font-size: 15px;
  margin-bottom:6px;
}
#nombreSeparata{
  font-weight: bold;
  line-height: 95%;
  height: 27px;
  max-width: 100%;
  text-overflow: ellipsis;
  outline:none;
}
.quitaSaltoLineas{
  /* border: solid 1px orange; */
  display: flex;
  justify-content: flex-end;
}
.Btn-BRL{
  /* justify-content: flex-end; */
  font-size: 11px;
  margin-top: 2px;
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 576px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  article.Form {
    padding-top: 10px;
    overflow-y: scroll;
  }
  .Blk-Campo {
    width:94%;
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
    margin-left:3%;
  }
  .Blk-Campo p{
    max-width:  80%;
  }
  .campo{
    width: 100%;
    margin: 0;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  #separataSelect p{
    max-width: 96%;
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .minusculas{
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  textarea.campo, input.campo, div.campo{
    width: 97%;
    margin-left:0%;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .quitaSaltoLineas{
    align-self: end;
    margin-right: 2%;
  }
}
</style>
